export default __webpack_public_path__ + "static/media/Restaurant-3.eaaadaef.jpg";